import { render } from "./contentApproval.vue?vue&type=template&id=c8a87a8e"
import script from "./contentApproval.vue?vue&type=script&lang=js"
export * from "./contentApproval.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__